import React from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { Membership, TotalOrders } from '../../../Svg';

const statuses = [
    {
        title: 'Total Orders',
        count: 50,
        
        icon: <TotalOrders />,
    },
    {
        title: 'Loyalty Points(Silver)',
        count: 1000,
        
        icon: <Membership />,
    },
    
];

const DashCards = () => {
    return (
        <Box sx={{ paddingBottom: '16px' }}>
            <Grid container spacing={2}>
                {statuses.map((status, index) => (
                    <Grid item xs={12} sm={6} md={6} key={index}>
                        <Card sx={{
                            display: 'flex', alignItems: 'flex-start',boxShadow:"none",
                            justifyContent: 'space-between', border: '1px solid #E0E2E7',
                        }}>
                            <CardContent>
                                <Typography variant="subtitle1" color="#777980" fontSize="16px">
                                    {status.title}
                                </Typography>
                                <Typography variant="h5" color="#1D1F2C" sx={{ p: '6px 0' }} fontSize="28px">
                                    {status.count}
                                </Typography>
                                <Typography variant="body2" color="#858D9D" fontSize="14px"> 
                                    {status.today}
                                </Typography>
                            </CardContent>
                            <Box sx={{ p: 2 }}>{status.icon}</Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default DashCards;
